import { FormSectionElements, FormSubSections } from "../entities/formTemplateDataType";
import DataUtils from "../utilities/DataUtils";
import { getRootComponent } from "../utilities/ElementUtils";
import { getRedirectPageOnReponse, getSubmitResponseData } from "../utilities/ResponseHandlerUtils";
import { handleResponse } from "./HandleResponseService";

export const getOtrisRedirectPage = (entity: any) => {
    let value;
    switch (entity?.statusCode) {
        case 2: value = 8;
        break;
        case 3: value = 9;
        break;
        case 55:
        case 5: value = 10;
        break;
        case 13: value = 11;
        break;
    }
    return value;
}

export const getOtrisRepsonseData = (field: FormSectionElements, response: any) => {
    return response.data?.WebResponse;
}

export const getAppResponseData = (field: FormSectionElements, response: any) => {
    const root = getRootComponent(field);
    if (root.CategoryId.toUpperCase() == 'OTRIS') {
        return getOtrisRepsonseData(field, response);
    }
    return getSubmitResponseData(field, response);
}

export const getRoutingPageOnAppResponse = (field: FormSectionElements, response: any) => {
    const root = getRootComponent(field);
    if (root.CategoryId.toUpperCase() == 'OTRIS') {
        const responseData = getOtrisRepsonseData(field, response);
        return getOtrisRedirectPage(getAppResponseData(field, responseData));
    }
    return getRedirectPageOnReponse(field, response);
}

export const handleResponseData = (field: FormSectionElements, entity: any, data?: any, callbackValidate?: (errors: any, fromAPI?:boolean) => void): any => {
    const root = getRootComponent(field);
    if (root.CategoryId?.toUpperCase()?.startsWith('OTRIS')) {
        root.Entity = data?.data;
        DataUtils.assignFormValue(root);
        return;
    }

    if (root.CategoryId?.toUpperCase()?.startsWith('ODR')) {
        return;
    }

    if (root.CategoryId?.toUpperCase()?.startsWith('VECON')) {
        return;
    }

    if (root.CategoryId.toUpperCase() == 'IRP-STATUS') {
        const section = field.parent as FormSubSections;
        const dataTables = section.ListOfFormSectionElements.filter(control => control.Datatype == 'DataTable')
        if (dataTables.length > 0) {
            const dataTable = dataTables[0] as FormSectionElements;
            dataTable.Value = data?.data;
            dataTable.Visible = data?.data?.length > 0;
            dataTable.TableData = {...dataTable.TableData ?? {}, paginator: data?.pagination, triggerPayload: entity };
        }

        const fieldFound = field.findFieldByName('Record__not__found');
        const statusDes = field.findFieldByName("explanation")
        const inquiry = field.findFieldByName("inquiry__assistant");
        if (fieldFound) {
            fieldFound.Visible = !(data?.data?.length > 0);
        }
        if (statusDes) {
            statusDes.Visible = data?.data?.length > 0;
        }
        if (inquiry) {
            inquiry.Visible = !(data?.data?.length > 0);
        }
        return;
    }

    // To handle service-calls of other projects.
    return handleResponse(root.CategoryId.toUpperCase(), data, field, callbackValidate);
}

export const cleanDataDueError = (field: FormSectionElements, errors?: FormSectionElements[]) => {
    const root = getRootComponent(field);
    if (root.CategoryId.toUpperCase() === 'IRP-STATUS') {
        const errorPanel = field.findFieldByName('Record__not__found');
        const statusDes = field.findFieldByName("explanation")
        const resultTable = field.findFieldByName("Search__results");
        const inquiry = field.findFieldByName("inquiry__assistant");
        if (resultTable) {
            resultTable.Value = null;
            resultTable.visible = false;
        }
        if (errorPanel) {
            errorPanel.Visible = true; //!(resultTable?.Value?.length > 0);
        }
        if (statusDes) {
            statusDes.Visible = false // resultTable?.Value?.length > 0;
        }
        if (inquiry) {
            inquiry.Visible = true;
        }
    }
}